import SchoolManagement from './SchoolManagement';
import generateSubappConfig from '../App/generateSubappConfig';
import ROUTES from '../routes.config';

const schoolManagementConfig = generateSubappConfig({
  path: ROUTES.schoolMgmt,
  isLive: true,
  navItemConfig: {
    label: 'New District / Ind. School',
  },
  appConfig: {
    Component: SchoolManagement,
  },
});

export default schoolManagementConfig;
